import { computed, inject, ref, unref } from 'vue'
import { formItemContextKey } from '@bigin/tokens'
import { buildProp } from '@bigin/utils'
import { componentSizes } from '@bigin/constants'
import { useProp } from '../use-prop'
import { useGlobalConfig } from '../use-global-config'
import type { ComponentSize } from '@bigin/constants'
import type { MaybeRef } from '@vueuse/core'

export const useSizeProp = buildProp({
  type: String,
  values: componentSizes,
  required: false,
} as const)

export const useSize = (
  fallback?: MaybeRef<ComponentSize | undefined>,
  ignore: Partial<Record<'prop' | 'form' | 'formItem' | 'global', boolean>> = {}
) => {
  const emptyRef = ref(undefined)

  const size = ignore.prop ? emptyRef : useProp<ComponentSize>('size')
  const large = ignore.prop ? emptyRef : useProp<boolean>('large')
  const small = ignore.prop ? emptyRef : useProp<boolean>('small')
  const globalConfig = ignore.global ? emptyRef : useGlobalConfig('size')
  const formItem = ignore.formItem
    ? { size: undefined }
    : inject(formItemContextKey, undefined)

  return computed(
    (): ComponentSize =>
      (large.value && 'large') ||
      (small.value && 'small') ||
      size.value ||
      unref(fallback) ||
      formItem?.size ||
      globalConfig.value ||
      ''
  )
}

export const useDisabled = (fallback?: MaybeRef<boolean | undefined>) => {
  const disabled = useProp<boolean>('disabled')
  return computed(() => disabled.value || unref(fallback) || false)
}
